import React, { useEffect, useState } from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  const [cupos, setCupos] = useState(15);
  const viewerSteps = [18, 19, 20, 22, 25];
  const [viewerIdx, setViewerIdx] = useState(0);
  useEffect(() => {
    const cupoTimer = setInterval(() => {
      setCupos(prev => prev > 6 ? prev - 1 : 6);
    }, 20000);
    return () => clearInterval(cupoTimer);
  }, []);
  useEffect(() => {
    const viewerTimer = setInterval(() => {
      setViewerIdx(prev => prev < viewerSteps.length - 1 ? prev + 1 : prev);
    }, 6000);
    return () => clearInterval(viewerTimer);
  }, []);
  const barPct = Math.max(40, Math.round(cupos / 15 * 85));
  return <section id="precio-lanzamiento" className="bg-familia-bg border-t border-familia-cyan/30 py-10 md:py-16 px-4 md:px-6" data-id="element-257">
      <div className="max-w-3xl mx-auto text-center w-[92%] md:w-full" data-id="element-258">
        <h2 className="text-familia-red font-bold text-sm sm:text-lg md:text-xl mb-5 md:mb-8 animate-blink uppercase tracking-widest text-center" data-id="element-259">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>
        <Countdown className="mb-5 md:mb-8 scale-90" data-id="element-260" />
        <p className="text-familia-gray text-xs sm:text-sm md:text-base mb-5 md:mb-8 text-center" data-id="element-261">
          El precio actual de lanzamiento puede aumentar cuando termine la
          promoción.
        </p>
        <div className="max-w-xl mx-auto bg-familia-card border border-familia-cyan/25 p-5 md:p-7 rounded-2xl" data-id="element-262">
          <div className="flex justify-center items-center mb-4" data-id="element-263">
            <span className="text-familia-red font-bold text-xs sm:text-sm" data-id="element-264">
              Oferta por tiempo limitado
            </span>
          </div>
          <div className="w-full bg-white/5 h-3 rounded-full overflow-hidden" data-id="element-265">
            <div className="bg-familia-cyan h-full transition-all duration-700 ease-out" style={{
            width: `${barPct}%`
          }} data-id="element-266" />
          </div>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-267">
            <span className="w-2 h-2 bg-familia-green rounded-full animate-pulse" data-id="element-268" />
            <span className="text-xs sm:text-sm text-familia-gray" data-id="element-269">
              <span className="text-white font-bold" data-id="element-270">
                {viewerSteps[viewerIdx]} personas
              </span>{' '}
              están viendo esta página ahora
            </span>
          </div>
        </div>
      </div>
    </section>;
};